/**
 * パスワード最小長
 */
export const PASSWORD_LENGTH_MIN = 8;

/**
 * パスワード最大長
 */
export const PASSWORD_LENGTH_MAX = 64;
